module.exports = __webpack_public_path__ + "static/media/guanggao20230705.6a788c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/v2/guanggao20230705.png
// module id = 683
// module chunks = 2